// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer__35uS-","inner":"inner__BuOt4"};